import React from 'react';
import pure from 'recompose/pure';
import PropTypes from 'prop-types';
var SwitchButton = function SwitchButton(_ref) {
  var enabled = _ref.enabled,
    loading = _ref.loading,
    toggle = _ref.toggle,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-toggle ".concat(className, " ").concat(enabled ? 'active' : ''),
    "aria-pressed": enabled,
    disabled: loading,
    onClick: toggle
  }, /*#__PURE__*/React.createElement("div", {
    className: "handle"
  }));
};
SwitchButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  className: PropTypes.string
};
SwitchButton.defaultProps = {
  className: ''
};
export default pure(SwitchButton);